import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  GET_MACHINE_INIT,
  CREATE_MACHINE_INIT,
  SEND_COMAND_MACHINE_INIT,
  DELETE_MACHINE_INIT,
  CONGELAR_MACHINE_INIT
} from '../../actionTypes';
import {
  getMachineSuccess,
  createMachineSuccess,
  sendCommandMachineSuccess,
  deleteMachineSuccess,
  errorMachine,
  congelarMachineInit,
  congelarMachineSuccess
} from './actions';
import {
  obterMachinePorEmpresa,
  criarMachine,
  excluirMachine,
  enviarComandoMaquina,
  congelarMachine
} from 'src/integracoes/servicos/pgloader/funcoes/machines';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { IMachine, SendCommandPayload } from 'src/integracoes/servicos/pgloader/modelos/IMachine';

// --------------------------- Obter machine por empresa ---------------------------------------------------------

const fetchObterMachine = async (empId: string) => {
  try {
    const { status, dados, mensagem } = await obterMachinePorEmpresa(empId);
    if (status) {
      return { isError: false, machine: dados ?? null, errorMessage: null };
    }
    return { isError: true, machine: null, errorMessage: mensagem || 'Erro ao obter máquina' };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseObterMachine({ payload }: any) {
  try {
    const { isError, machine, errorMessage } = yield call(fetchObterMachine, payload);
    if (!isError) {
      yield put(getMachineSuccess(machine));
    } else {
      yield put(errorMachine({ msg: errorMessage }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorMachine({ msg: mensagem }));
  }
}

function* watchObterMachine() {
  yield takeEvery(GET_MACHINE_INIT, parseObterMachine);
}

/* ------------------Criar machine ---------------- */
const fetchCriarMachine = async (machine: IMachine) => {
  try {
    const { status, dados, mensagem } = await criarMachine(machine);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarMachine({ payload }: { payload: any; type: any }) {
  const { machine } = payload;

  try {
    const { isCreated, msg, data } = yield call(fetchCriarMachine, machine);
    if (isCreated) {
      yield put(createMachineSuccess({ isCreated, machine: data, msg: msg }));
    } else {
      yield put(errorMachine({ msg }));
    }
  } catch (error: any) {
    yield put(
      errorMachine({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`
      })
    );
  }
}

function* watchCriarMachine() {
  yield takeEvery(CREATE_MACHINE_INIT, parseCriarMachine);
}

/* ------------------Deletar machine ---------------- */
const fetchDeletarMachine = async (id: string, userId: string, email: string) => {
  try {
    const { status, mensagem } = await excluirMachine(id, userId, email);
    if (status) {
      return { isDeleted: true, msg: mensagem };
    } else {
      return {
        isDeleted: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarMachine({ payload }: { payload: any; type: any }) {
  const { id, userId, email } = payload;
  try {
    const { isDeleted, msg } = yield call(fetchDeletarMachine, id, userId, email);

    if (isDeleted) {
      yield put(
        deleteMachineSuccess({
          isDeleted,
          msg,
          id
        })
      );
    } else {
      yield put(errorMachine({ msg }));
    }
  } catch (error: any) {
    yield put(
      errorMachine({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`
      })
    );
  }
}

function* watchDeletarMachine() {
  yield takeEvery(DELETE_MACHINE_INIT, parseDeletarMachine);
}

/* ------------------Congelar machine ---------------- */
const fetchCongelarMachine = async (id: string, userId: string, email: string) => {
  try {
    const { status, mensagem } = await congelarMachine(id, userId, email);
    if (status) {
      return { isUpdated: true, msg: mensagem };
    } else {
      return {
        isUpdated: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCongelarMachine({ payload }: { payload: any; type: any }) {
  const { id, userId, email } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchCongelarMachine, id, userId, email);

    if (isUpdated) {
      yield put(
        congelarMachineSuccess({
          isUpdated,
          msg,
          id
        })
      );
    } else {
      yield put(errorMachine({ msg }));
    }
  } catch (error: any) {
    yield put(
      errorMachine({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`
      })
    );
  }
}

function* watchCongelarMachine() {
  yield takeEvery(CONGELAR_MACHINE_INIT, parseCongelarMachine);
}

/* ------------------ Enviar comando ---------------- */
const fetchEnviarComandoMachine = async (
  id: string,
  command: string,
  userId: string,
  email: string,
  empId: string,
  whitelabel: string
) => {
  try {
    const { status, mensagem } = await enviarComandoMaquina(
      id,
      command,
      userId,
      email,
      empId,
      whitelabel
    );

    if (status) {
      return { isUpdated: true, msg: mensagem };
    } else {
      return {
        isUpdated: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseEnviarComandoMachine({ payload }: { payload: any; type: any }) {
  try {
    const { isUpdated, msg } = yield call(
      fetchEnviarComandoMachine,
      payload.id,
      payload.command,
      payload.userId,
      payload.email,
      payload.empId,
      payload.whitelabel
    );

    if (isUpdated) {
      yield put(
        sendCommandMachineSuccess({
          isUpdated,
          msg
        })
      );
    } else {
      yield put(errorMachine({ msg }));
    }
  } catch (error: any) {
    yield put(
      errorMachine({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`
      })
    );
  }
}

function* watchEnviarComandoMachine() {
  yield takeEvery(SEND_COMAND_MACHINE_INIT, parseEnviarComandoMachine);
}

export default function* machinesSaga() {
  yield all([
    fork(watchObterMachine),
    fork(watchCriarMachine),
    fork(watchDeletarMachine),
    fork(watchCongelarMachine),
    fork(watchEnviarComandoMachine)
  ]);
}
